import "jquery";
import * as ko from "knockout";
import {GrowerSegmentViewModel  } from "../ViewModels/GrowerSegmentViewModel";
import { BenchmarkApi } from "../apis/BenchmarkApi";
import { BenchmarkParameter } from "../Models/BenchmarkParameter";
import { GrowerSegmentData, SegmentSpecies } from "../Models/Segment/GrowerSegmentData";
import { forEach } from "../../../node_modules/@types/lodash-es/index";
import * as Highcharts from 'highcharts';
import HighchartsMore from "highcharts/highcharts-more";
import { SegmentApi } from "../Apis/SegmentApi";



export class GrowerSegment {
    SegmentApi: SegmentApi;

    private $cropNumber: JQuery;
    private $nettoAmount: JQuery;
    private $growerIndex: JQuery;
    private $segment: JQuery;
    private $interval: JQuery;

    growerSegmentViewModel: GrowerSegmentViewModel;
    $viewModelAnchor: JQuery;
    constructor() {
        
        this.SegmentApi = SegmentApi.getInstance(); 
        this.$cropNumber = $("#cropNumber");
        this.$nettoAmount = $("#nettoAmount");
        this.$growerIndex = $("#growerIndex");
        this.$segment = $("#segmentRank");
        this.$interval = $("#interval");

        this.$viewModelAnchor = $('#grower-segment');
        this.growerSegmentViewModel = new GrowerSegmentViewModel();
        //Binds the viewmodel to the template
        if (this.$viewModelAnchor[0]) {
            ko.applyBindings(this.growerSegmentViewModel, this.$viewModelAnchor[0]);

        }
        
    }

    async init(test: string): Promise<void> {
        
        this.growerSegmentViewModel.isLoading(true);
        let segmentData = await this.SegmentApi.getSegmentData();
        this.growerSegmentViewModel.isLoading(false); 
        if (segmentData.NumberOfCrops === 0) {
            this.growerSegmentViewModel.noData(true); 
            return;
        }
        this.growerSegmentViewModel.showFigure(true);

        this.$cropNumber.text(segmentData.NumberOfCrops);
        this.$nettoAmount.text(segmentData.AverageAmountPrHa.toLocaleString('da-DK',
            { maximumFractionDigits: 0, minimumFractionDigits: 0 }));
        this.$growerIndex.text(segmentData.GrowerIndex.toLocaleString('da-DK',
            { maximumFractionDigits: 2, minimumFractionDigits: 2 }));
        this.$segment.text(segmentData.Rank);
        this.$interval.text((segmentData.LastCropYear - 4).toString() + " - " + segmentData.LastCropYear);

        HighchartsMore(Highcharts);
        this.createChart(test,segmentData);

        let years: number[] = []; 
        for (let i = segmentData.LastCropYear - 4; i <= segmentData.LastCropYear; i++) {
            years.push(i);
        }

        let tile = document.getElementsByName("tile");
        var tileId = 0;
        try {
            segmentData.SegmentSpeciesList.forEach(x => {
                this.segmentChart(tile[tileId], x, years);
                tileId++;

            });
        } catch (error) {
            console.log(error);
        }

        for (let i = tileId; i < tile.length; i++) {
            this.segmentChart(tile[tileId],
                <SegmentSpecies>{
                    Name: '',
                    Id: '',
                    Varieties:[]
                }, years);
            tileId++;
        }


        



        let tile2 = document.getElementsByName("tile2");
        tile2.forEach(y => this.chartWithTicks(y,years));
        
    }
    
    private colors() {
        return ['rgb(25,72,204)', 'rgb(20,95,42)', 'rgb(0,166,81)', 'red', 'black', 'green', 'purple'];
    }

    private createChart(title:string, growerSegmentData: GrowerSegmentData) {
        let id = "chart1";

        let c = (growerSegmentData.RankData.CThreshold / growerSegmentData.RankData.MaxRank) * 100;
        let b = ((growerSegmentData.RankData.BThreshold / growerSegmentData.RankData.MaxRank) * 100) - c;
        let a = 100 - b - c;

        let point = (growerSegmentData.GrowerRank / growerSegmentData.RankData.MaxRank) * 100; 

        
        //@ts-ignore
        let myChart = Highcharts.chart(id, {
            credits: {
                enabled: false
            },
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: 0,
                plotShadow: false
            },
            title: {
                text: null,
            },
            tooltip: {
                enabled:false,
            },
            pane: {
                center: ['50%', '71.85%'],
                size: '50%',
                startAngle: -90,
                endAngle: 90,
                background: {
                    borderWidth: 0,
                    backgroundColor: 'none',
                    innerRadius: '60%',
                    outerRadius: '100%',
                    shape: 'arc'
                }
            },
            yAxis: [{
                lineWidth: 0,
                min: 0,
                max: 100,
                minorTickLength: 0,
                tickLength: 0,
                tickWidth: 0,
                labels: {
                    enabled: false
                },
                title: {
                    text: '', 
                    useHTML: true,
                    y: 80
                },
                pane: 0,

            }],
            plotOptions: {
                pie: {
                    dataLabels: {
                        enabled: true,
                        distance: -50,
                        style: {
                            fontWeight: 'bold',
                            color: 'white',
                            fontSize: '15px',
                            textOutline: "0px"
                        }
                    },
                    startAngle: -90,
                    endAngle: 90,
                    center: ['50%', '75%'],
                    size: '110%'
                },
                gauge: {
                    dataLabels : {
                        enabled : false
                    },
                    dial: {
                        radius: '130%',
                    }
                }
            },
            series: [{
                type: 'pie',
                name: 'Browser share',
                innerSize: '50%',
                allowPointSelect: false,
                states: {
                    inactive: {
                        opacity: 1
                    },
                    hover: {
                        enabled: false,
                        opacity: 1,
                        halo: {
                            opacity:1
                        }
                    }
                },
                data: [
                    { name: 'C', color: 'rgb(25,72,204)',   y: c },
                    { name: 'B', color: 'rgb(20,95,42)', y: b },
                    { name: 'A', color: 'rgb(0,166,81)', y: a }
                ]
                },
                {
                    type: "gauge",
                    data: [point],
                    dial: { rearLength: 0 },
                    allowPointSelect: false,
                    states: {
                        inactive: {
                            opacity:1
                        },
                        hover: {
                            enabled: false,
                            opacity: 1,
                            halo: {
                                opacity: 1
                            }
                        }
                    }
                }]
        });

    }

    

    private segmentChart(tile: any, segmentSpecies: SegmentSpecies, years:number[]) {
        let series :any[] = [];

        let cols = this.colors();
        let currentCol = 0; 
        segmentSpecies.Varieties.forEach(variety => {
            let col = cols[currentCol];
            currentCol++;
            let varietyData: any[] = []; 
            years.forEach(year => {
                let index = variety.VarietyData.find(x => x.Year === year);
                if (index != null) {
                    varietyData.push(index.Index); 
                } else {
                    varietyData.push(null); 
                }

            });

            let serie = {
                name: variety.Name,
                showInLegend: false,
                marker: {
                    symbol: 'diamond',
                    radius: 4
                },
                data: varietyData,
                color: col
            };
            series.push(serie); 
        });

        console.log(series, tile);
        

        //@ts-ignore
        Highcharts.chart(tile, {
            credits: {
                enabled: false
            },
            chart: {
                height: 150,
                width:300,
                type: 'spline'
            },
            title: {
                text: segmentSpecies.Name,
                align: 'left'

            },
            xAxis: {
                visible: false,
                categories: years
            },
            yAxis: {
                visible:false,
                title: {
                    text: null
                },
                labels: {
                    formatter: function () {
                        return this.value + '°';
                    }
                }
            },
            plotOptions: {
                series: {
                    lineWidth: 3,
                    dataLabels : {
                        enabled: true,
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0);
                        }
                    }
                }
            },
            series: series
        });

    }


    private chartWithTicks(tile :any, years :number[]) {

        //@ts-ignore
        Highcharts.chart(tile, {
            credits: {
                enabled: false
            },
            chart: {
                height: 150,
                width: 300,
                type: 'spline'
            },
            title: {
                text: null

            },
            subtitle: {
                text: null
            },
            xAxis: {
                visible: true,
                categories: years
            },
            yAxis: {
                visible: false,
                title: {
                    text: null
                },
                labels: {
                    formatter: function () {
                        return this.value + '°';
                    }
                }
            },
            plotOptions: {
                spline: {
                    marker: {
                        radius: 4,
                        lineColor: '#FFFFFF',
                        lineWidth: 1
                    }
                }
            },
            series: [{
                name: null,
                showInLegend: false,
                marker: {
                    symbol: 'diamond'
                },
                data:[null,null,null,null,null],
                color: "#FFFFFF"
            }]
        });

    }
    
}